import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-documentos-institucion',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './documentos-institucion.component.html',
  styleUrl: './documentos-institucion.component.css',
})
export class DocumentosInstitucionComponent implements OnInit {
  documents: any[] = [];
  filteredDocuments: any[] = [];
  unidadesFuncionales: any[] = [];
  oficinas: any[] = [];
  oficinasFiltradas: any[] = [];
  selectedUnidadFuncional: string = '';
  selectedOficina: string = '';
  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 1;
  idInstitucionEducativa: string | null = null;
  user: any = null;

  selectedStatus: string = '';
  selectedDateOrder: string = '';

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit(): void {
    this.loadUserData();
    this.fetchUnidadesFuncionales();
    this.fetchOficinas();
    this.fetchDocuments();
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      this.user = JSON.parse(userData);
      this.idInstitucionEducativa = this.user?.id_institucion_educativa || null;
    } else {
      console.error('No se encontró información de usuario en localStorage.');
    }
  }

  fetchUnidadesFuncionales(): void {
    this.http
      .get<any[]>(environment.apiUrl + '/unidad-funcional')
      .subscribe((data) => (this.unidadesFuncionales = data));
  }

  fetchOficinas(): void {
    this.http.get<any[]>(environment.apiUrl + '/oficina').subscribe((data) => {
      this.oficinas = data;
      this.oficinasFiltradas = data; // Mostrar todas al inicio
    });
  }

  onUnidadFuncionalChange(): void {
    if (this.selectedUnidadFuncional) {
      this.oficinasFiltradas = this.oficinas.filter(
        (o) =>
          o.unidadFuncional.id_unidad_funcional == this.selectedUnidadFuncional
      );
    } else {
      this.oficinasFiltradas = this.oficinas;
    }
    this.selectedOficina = ''; // Resetear oficina seleccionada
  }

  fetchDocuments(): void {
    let apiUrl =
      environment.apiUrl +
      '/documento/institucion/' +
      `${this.idInstitucionEducativa}`;
    const queryParams: any = {};

    if (this.selectedUnidadFuncional) {
      queryParams.id_unidad_funcional = this.selectedUnidadFuncional;
    }

    if (this.selectedOficina) {
      queryParams.id_oficina = this.selectedOficina;
    }

    if (this.selectedStatus) {
      queryParams.by_status = this.selectedStatus;
    }

    if (this.selectedDateOrder) {
      queryParams.by_date = this.selectedDateOrder;
    }

    queryParams.estado = 1;
    //console.log(queryParams);
    this.http.get<any[]>(apiUrl, { params: queryParams }).subscribe(
      (data) => {
        this.documents = data;
        this.filteredDocuments = data; // Inicializar filteredDocuments con la lista completa
        this.updatePagination();
      },
      (error) => console.error('Error al obtener documentos:', error)
    );
  }

  applyFilter(): void {
    // Filtrar documentos basados en el texto de búsqueda
    this.filteredDocuments = this.documents.filter(
      (doc) =>
        doc.nombre
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase()) ||
        doc.id_documento
          .toString()
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
    );

    // Reiniciar la paginación a la primera página
    this.currentPage = 1;

    // Actualizar la paginación
    this.updatePagination();
  }

  updatePagination(): void {
    // const startIndex = (this.currentPage - 1) * this.pageSize;
    // const endIndex = startIndex + this.pageSize;

    // // Asegúrate de que filteredDocuments esté actualizado
    // this.filteredDocuments = this.documents
    //   .filter((doc) =>
    //     doc.nombre.toLowerCase().includes(this.searchText.toLowerCase())
    //   )
    //   .slice(startIndex, endIndex);

    // Calcular el número total de páginas
    this.totalPages = Math.ceil(this.filteredDocuments.length / this.pageSize);
  }

  getPaginatedDocuments(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredDocuments.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.updatePagination();
  }

  goToDocumentDetail(doc: any): void {
    this.router.navigate(['/documento-institucion'], {
      queryParams: {
        id_documento_cargado: doc.documentos_cargados[0].id_documento_cargado,
      },
    });
  }

  goToRegisterPage(doc: any): void {
    this.router.navigate(['/create-documento-cargado'], {
      queryParams: { id_documento: doc.id_documento },
    });
  }

  goBack(): void {
    this.router.navigate(['/main-user']);
  }
}
